import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataTablesResponse } from '../models/datatables';
import { environment } from '../../environments/environment';
import { AmbassadorProgramCompanyVehicleDTO } from '../models/ambassador-program-company-vehicle-dto';
import { Select2Data } from 'ng-select2-component';

@Injectable({
  providedIn: 'root'
})

export class AmbassadorProgramCompanyVehicleService {

  private pathAPI = environment.urlAPI;
  private controller = "AmbassadorProgramCompanyVehicle/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<AmbassadorProgramCompanyVehicleDTO> {
    return this.http.get<AmbassadorProgramCompanyVehicleDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: FormData): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }
    
  public getDataTable(data: any, idProgram: string, idCompany: string): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/' + idProgram + '/' + idCompany, data);
  }

  public getByUser(): Observable<AmbassadorProgramCompanyVehicleDTO[]> {
    return this.http.get<AmbassadorProgramCompanyVehicleDTO[]>(this.pathAPI + this.controller + 'GetByUser');
  }

  public getAllForSelect(idProgram: string, idCompany: string): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'GetAllForSelect/' + idProgram + '/' + idCompany);
  }

}
